/**
 * lg-cart.js — LostGear cart page JS
 * Handles: qty +/−, remove, express toggle, upsell add-to-cart
 */
(function () {
  'use strict';

  var SECTION_ID = null;

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    var root = document.getElementById('lg-cart-section');
    if (!root) return;
    SECTION_ID = root.dataset.sectionId;

    // Delegation for qty and remove (these are dynamic, so document-level is fine)
    document.addEventListener('click', onDocClick);

    // Direct binding for express toggle (most reliable)
    bindExpressBtn();

    bootCartNote();
    bootAcceleratedCheckoutLayout();
    autoRemoveInvalidExpress();
  }

  // ── Document-level delegation (qty / remove / upsell) ────────────────────

  function onDocClick(e) {
    var qtyBtn    = e.target.closest('[data-qty-action]');
    var removeBtn = e.target.closest('[data-remove]');
    var upsellBtn = e.target.closest('[data-upsell-add]');

    if (qtyBtn)    { e.preventDefault(); handleQty(qtyBtn);         return; }
    if (removeBtn) { e.preventDefault(); handleRemove(removeBtn);   return; }
    if (upsellBtn) { e.preventDefault(); handleUpsellAdd(upsellBtn); return; }
  }

  // ── Direct express binding ────────────────────────────────────────────────

  function bindExpressBtn() {
    var btn = document.querySelector('[data-express-btn]');
    if (!btn || btn._lgExpressBound) return;
    btn._lgExpressBound = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      handleExpress();
    });
  }

  // ── Qty change ────────────────────────────────────────────────────────────

  function handleQty(btn) {
    var itemEl = btn.closest('[data-item-index]');
    if (!itemEl) return;

    var lineIndex = parseInt(itemEl.dataset.itemIndex, 10);
    var valEl     = itemEl.querySelector('[data-qty-val]');
    var current   = parseInt(valEl ? valEl.textContent : 1, 10) || 1;
    var newQty    = btn.dataset.qtyAction === 'plus' ? current + 1 : Math.max(1, current - 1);

    if (valEl) valEl.textContent = newQty;
    itemEl.classList.add('is-loading');

    var lineKey = itemEl.dataset.lineKey;
    var configurationId = itemEl.dataset.configurationId;
    var childRows = Array.prototype.filter.call(
      document.querySelectorAll('[data-is-nested-addon="true"]'),
      function (row) {
        return configurationId && row.dataset.configurationId === configurationId;
      }
    );

    if (lineKey && childRows.length) {
      var updates = {};
      updates[lineKey] = newQty;
      childRows.forEach(function (row) {
        if (row.dataset.lineKey) updates[row.dataset.lineKey] = newQty;
        row.classList.add('is-loading');
      });
      cartUpdate(updates);
      return;
    }

    cartChange({ line: lineIndex, quantity: newQty });
  }

  // ── Remove ────────────────────────────────────────────────────────────────

  function handleRemove(btn) {
    var itemEl = btn.closest('[data-item-index]');
    if (!itemEl) return;

    itemEl.style.transition = 'opacity .2s, transform .2s';
    itemEl.style.opacity    = '0';
    itemEl.style.transform  = 'translateX(12px)';

    var lineKey = itemEl.dataset.lineKey;
    var configurationId = itemEl.dataset.configurationId;
    var childRows = Array.prototype.filter.call(
      document.querySelectorAll('[data-is-nested-addon="true"]'),
      function (row) {
        return configurationId && row.dataset.configurationId === configurationId;
      }
    );

    if (lineKey && childRows.length) {
      var updates = {};
      updates[lineKey] = 0;
      childRows.forEach(function (row) {
        if (row.dataset.lineKey) updates[row.dataset.lineKey] = 0;
        row.classList.add('is-loading');
      });
      cartUpdate(updates);
      return;
    }

    cartChange({ line: parseInt(itemEl.dataset.itemIndex, 10), quantity: 0 });
  }

  // ── Express toggle (optimistic) ───────────────────────────────────────────

  function handleExpress() {
    var root      = document.getElementById('lg-cart-section');
    if (!root) return;
    if (root.dataset.hasBlocker === 'true') return;

    var expressEl = root.querySelector('#lg-express-block');
    var isIn      = root.dataset.expressInCart === 'true';
    var variantId = root.dataset.expressVariant;
    if (!variantId) return;

    // Prevent double-clicks while in flight
    if (expressEl && expressEl.classList.contains('lg-express--loading')) return;

    // ── Optimistic: flip active/idle immediately ──
    if (expressEl) {
      expressEl.classList.remove('lg-express--active', 'lg-express--idle');
      expressEl.classList.add(isIn ? 'lg-express--idle' : 'lg-express--active');
      expressEl.classList.add('lg-express--loading');
      var expressBtn = expressEl.querySelector('[data-express-btn]');
      if (expressBtn) expressBtn.setAttribute('aria-pressed', isIn ? 'false' : 'true');
    }

    // Checkout button → loading state
    var checkoutBtn = root.querySelector('.lg-cart__checkout-btn');
    if (checkoutBtn) checkoutBtn.classList.add('is-loading');

    if (isIn) {
      cartChange(
        { line: parseInt(root.dataset.expressLine, 10), quantity: 0 },
        updateExpressUI,
        function () { revertExpressOptimism(expressEl, true); }
      );
    } else {
      cartAdd(
        { id: parseInt(variantId, 10), quantity: 1 },
        updateExpressUI,
        function () { revertExpressOptimism(expressEl, false); }
      );
    }
  }

  function revertExpressOptimism(expressEl, wasIn) {
    if (!expressEl) return;
    expressEl.classList.remove('lg-express--loading', 'lg-express--active', 'lg-express--idle');
    expressEl.classList.add(wasIn ? 'lg-express--active' : 'lg-express--idle');
    var expressBtn = expressEl.querySelector('[data-express-btn]');
    if (expressBtn) expressBtn.setAttribute('aria-pressed', wasIn ? 'true' : 'false');
    var root = document.getElementById('lg-cart-section');
    var checkoutBtn = root ? root.querySelector('.lg-cart__checkout-btn') : null;
    if (checkoutBtn) checkoutBtn.classList.remove('is-loading');
  }

  // Surgical DOM update after express add/remove — no full section swap
  function updateExpressUI(data) {
    var html = data.sections && (data.sections[SECTION_ID] || data.sections['lg-cart']);
    if (!html) { window.location.reload(); return; }

    var doc     = new DOMParser().parseFromString(html, 'text/html');
    var newRoot = doc.getElementById('lg-cart-section');
    var curRoot = document.getElementById('lg-cart-section');
    if (!newRoot || !curRoot) { window.location.reload(); return; }

    // Update root dataset so next toggle reads the right state
    curRoot.dataset.expressInCart  = newRoot.dataset.expressInCart;
    curRoot.dataset.expressLine    = newRoot.dataset.expressLine;
    curRoot.dataset.expressVariant = newRoot.dataset.expressVariant;
    curRoot.dataset.hasEligible    = newRoot.dataset.hasEligible;
    curRoot.dataset.hasBlocker     = newRoot.dataset.hasBlocker;

    // Update items list (express item row appears / disappears)
    var oldItems = document.getElementById('lg-cart-items');
    var newItems = doc.getElementById('lg-cart-items');
    if (oldItems && newItems) oldItems.innerHTML = newItems.innerHTML;

    // Update totals block (subtotal / express line / shipping)
    var oldTotals = document.getElementById('lg-cart-totals');
    var newTotals = doc.getElementById('lg-cart-totals');
    if (oldTotals && newTotals) oldTotals.innerHTML = newTotals.innerHTML;

    // Update express toggle block so visual state stays in sync
    var oldExpress = document.getElementById('lg-express-block');
    var newExpress = doc.getElementById('lg-express-block');
    if (oldExpress && newExpress) {
      oldExpress.outerHTML = newExpress.outerHTML;
    } else if (oldExpress && !newExpress) {
      oldExpress.remove();
    }

    // Update grand total
    var oldGrand = curRoot.querySelector('.lg-cart__grand-total');
    var newGrand = doc.querySelector('.lg-cart__grand-total');
    if (oldGrand && newGrand) oldGrand.innerHTML = newGrand.innerHTML;

    // Update checkout button total
    var oldCheckoutTotal = document.querySelector('[data-checkout-total]');
    var newCheckoutTotal = doc.querySelector('[data-checkout-total]');
    if (oldCheckoutTotal && newCheckoutTotal) oldCheckoutTotal.textContent = newCheckoutTotal.textContent;

    // Update item count in heading
    var oldCount = curRoot.querySelector('.lg-cart__count');
    var newCount = doc.querySelector('.lg-cart__count');
    if (oldCount && newCount) oldCount.textContent = newCount.textContent;

    // Remove loading states
    var expressEl = curRoot.querySelector('#lg-express-block');
    if (expressEl) expressEl.classList.remove('lg-express--loading');
    var checkoutBtn = curRoot.querySelector('.lg-cart__checkout-btn');
    if (checkoutBtn) checkoutBtn.classList.remove('is-loading');

    bindExpressBtn();

    // Update Dawn header cart bubble
    var nb = doc.querySelector('.cart-count-bubble');
    var cb = document.querySelector('.cart-count-bubble');
    if (nb && cb) cb.innerHTML = nb.innerHTML;
  }

  // ── Upsell ────────────────────────────────────────────────────────────────

  function handleUpsellAdd(btn) {
    var card = btn.closest('[data-upsell-card]');
    if (!card) return;

    var variantId = parseInt(card.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled  = true;
    btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Adding…';

    cartAdd({ id: variantId, quantity: 1 });
  }

  // ── Cart API ──────────────────────────────────────────────────────────────

  function cartChange(payload, onSuccess, onError) {
    payload.sections = [SECTION_ID];

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify(payload)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        console.error('lg-cart cartChange error', data.status, data.description);
        if (onError) onError(); else window.location.reload();
        return;
      }
      if (onSuccess) {
        onSuccess(data);
      } else {
        var html = data.sections && (data.sections[SECTION_ID] || data.sections['lg-cart']);
        if (html) renderSection(html); else window.location.reload();
      }
    })
    .catch(function (err) {
      console.error('lg-cart cartChange fetch error', err);
      if (onError) onError(); else window.location.reload();
    });
  }

  function cartUpdate(updates) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates, sections: [SECTION_ID] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status || data.errors) {
        console.error('lg-cart cartUpdate error', data.status || data.errors, data.description);
        window.location.reload();
        return;
      }
      var html = data.sections && (data.sections[SECTION_ID] || data.sections['lg-cart']);
      if (html) renderSection(html); else window.location.reload();
    })
    .catch(function (err) {
      console.error('lg-cart cartUpdate fetch error', err);
      window.location.reload();
    });
  }

  function cartAdd(payload, onSuccess, onError) {
    payload.sections = [SECTION_ID];

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify(payload)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        console.error('lg-cart cartAdd error', data.status, data.description);
        if (onError) onError(); else window.location.reload();
        return;
      }
      if (onSuccess) {
        onSuccess(data);
      } else {
        var html = data.sections && (data.sections[SECTION_ID] || data.sections['lg-cart']);
        if (html) renderSection(html); else window.location.reload();
      }
    })
    .catch(function (err) {
      console.error('lg-cart cartAdd fetch error', err);
      if (onError) onError(); else window.location.reload();
    });
  }

  // ── Section render (full swap — used for qty/remove/upsell) ──────────────

  function renderSection(html) {
    var noteEl  = document.getElementById('lg-cart-note');
    var noteVal = noteEl ? noteEl.value : '';

    var doc     = new DOMParser().parseFromString(html, 'text/html');
    var newRoot = doc.getElementById('lg-cart-section');
    var curRoot = document.getElementById('lg-cart-section');
    if (!newRoot || !curRoot) { window.location.reload(); return; }

    curRoot.innerHTML                  = newRoot.innerHTML;
    curRoot.dataset.expressInCart      = newRoot.dataset.expressInCart;
    curRoot.dataset.expressLine        = newRoot.dataset.expressLine;
    curRoot.dataset.expressVariant     = newRoot.dataset.expressVariant;
    curRoot.dataset.hasEligible        = newRoot.dataset.hasEligible;
    curRoot.dataset.hasBlocker         = newRoot.dataset.hasBlocker;

    if (noteVal) {
      var n = document.getElementById('lg-cart-note');
      if (n) n.value = noteVal;
    }

    // Rebind express button (new DOM node after innerHTML swap)
    bindExpressBtn();
    bootCartNote();

    // Update Dawn header cart bubble
    var nb = doc.querySelector('.cart-count-bubble');
    var cb = document.querySelector('.cart-count-bubble');
    if (nb && cb) cb.innerHTML = nb.innerHTML;

    // Auto-remove express if no eligible items remain
    autoRemoveInvalidExpress();
  }

  // ── Auto-remove express when cart state makes it invalid ─────────────────

  function autoRemoveInvalidExpress() {
    var root = document.getElementById('lg-cart-section');
    if (!root) return;
    if (root.dataset.expressInCart !== 'true') return;
    if (root.dataset.hasEligible === 'true' && root.dataset.hasBlocker !== 'true') return;

    var line = parseInt(root.dataset.expressLine, 10);
    if (!line) return;
    cartChange({ line: line, quantity: 0 });
  }

  // ── Accelerated checkout row layout ───────────────────────────────────────
  // shopify-accelerated-checkout-cart uses shadow DOM slots, so CSS alone
  // cannot change the stacking layout. We apply inline flex after the custom
  // elements have connected and rendered their shadow roots.

  function applyAcceleratedCheckoutRowLayout() {
    var host = document.querySelector('shopify-accelerated-checkout-cart');
    if (!host) return;

    // Force the host to be a flex row so slotted elements line up
    host.style.display = 'flex';
    host.style.flexDirection = 'row';
    host.style.flexWrap = 'nowrap';
    host.style.gap = '6px';
    host.style.width = '100%';

    // Give each wallet button element equal flex width
    var WALLET_TAGS = [
      'shop-pay-wallet-button',
      'shopify-apple-pay-button',
      'shopify-paypal-button',
      'shopify-google-pay-button'
    ];
    WALLET_TAGS.forEach(function (tag) {
      var el = host.querySelector(tag);
      if (!el) return;
      el.style.flex = '1 1 0%';
      el.style.minWidth = '0';
      el.style.overflow = 'hidden';
    });

    // Also try shadow root if Shopify uses open mode
    var shadow = host.shadowRoot;
    if (shadow) {
      var inner = shadow.querySelector('div, form');
      if (inner) {
        inner.style.display = 'flex';
        inner.style.flexDirection = 'row';
        inner.style.gap = '6px';
      }
    }
  }

  function bootAcceleratedCheckoutLayout() {
    // Run immediately in case elements are already in the DOM
    applyAcceleratedCheckoutRowLayout();

    // Watch for the custom element to be inserted / upgraded
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          applyAcceleratedCheckoutRowLayout();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Belt-and-suspenders: retry after element upgrade delays
    setTimeout(applyAcceleratedCheckoutRowLayout, 500);
    setTimeout(applyAcceleratedCheckoutRowLayout, 1500);
  }

  // ── Cart note polyfill ────────────────────────────────────────────────────

  function bootCartNote() {
    if (customElements.get('cart-note')) return;
    try {
      customElements.define('cart-note', class extends HTMLElement {
        connectedCallback() {
          var ta = this.querySelector('textarea');
          if (!ta || ta._lgBound) return;
          ta._lgBound = true;
          ta.addEventListener('input', debounce(function () {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: ta.value })
            });
          }, 400));
        }
      });
    } catch (e) { /* already defined by Dawn's cart.js */ }
  }

  // ── Util ──────────────────────────────────────────────────────────────────

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, a); }, ms);
    };
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
